import { defineMessages } from 'react-intl';

export default defineMessages({
  ALWAYS: 'Always',
  WITH_CONSENT: 'With consent',
  NEVER: 'Never',
});
